// src/index.js
import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom'; // Import BrowserRouter
import './index.css';
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    {/* Wrap App in BrowserRouter to enable routing functionality */}
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);